/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo, useState } from "react";
import { JoySpaceDocumentMessage, SessionType } from "@/types/chat";
import { HeadShowType, MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import "./index.less";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { openUserCardModal } from "@/components/AddressBook/common";
import Context from "@/components/chat/context";
import ShareAppCard from "./ShareAppCard";
import ChatState from "@/types/chat/State";
import { getTextMessageRemark } from "@/components/chat/utils/commonMessageModal";
import { connect } from "dva";
import ReferenceHeader from "../ReferenceHeader";

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

function ShareAppCardList(props: any) {
  const { currentEmployee, selectedSession, message, sessionType, sendType, onReady } = props;
  const [showMore, setShowMore] = useState<boolean>(false);
  const showFooter = useMemo(() => {
    return (message?.data?.length || 0) > 3 && !showMore;
  }, [message?.data?.length, showMore]);

  // 扩展数据
  const extData = useMemo(() => {
    if (!message?.ext) {
      return {};
    }
    try {
      return typeof message?.ext === "string" ? JSON.parse(message?.ext) : message?.ext;
    } catch (e) {
      return {};
    }
  }, [message?.ext]);

  const aiTitle = useMemo(() => {
    return extData?.ai_type || "";
  }, [extData.ai_type]);

  return (
    <div className="content">
      <div className={`card-container-app ${sendType === MessageSendType.OTHER ? "other" : ""}`}>
        {aiTitle ? (
          <div className="share-card-title-wrap">
            <span>使用</span>
            <div className="title-name">{`「${aiTitle}」`}</div>
          </div>
        ) : null}
        <ReferenceHeader refs={message?.refs} />
        <div
          className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
          dangerouslySetInnerHTML={{
            __html: getTextMessageRemark(selectedSession, message, currentEmployee, "", -1).trim()
          }}
        />
        {message?.data?.length ? (
          <div className={`card-wrap${showMore ? " showMore" : ""}`}>
            {message?.data?.map((d: any, idx: number) => {
              return (
                <ShareAppCard
                  sendType={sendType}
                  onReady={onReady}
                  message={{ ...message, data: [d] }}
                  sessionType={sessionType}
                  key={`${message.id}_${idx}`}
                  clsName="small-card"
                  showFooter={false}
                />
              );
            })}
          </div>
        ) : null}
        {showFooter ? (
          <div className="footer" onClick={() => setShowMore(true)}>
            查看更多
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareAppCardList);
